<template>
  <div class="relative py-24 sm:py-32 min-h-fit">
    <UiContainer>
      <div class="mx-auto max-w-7xl">
        <UiTitle
          size="5xl"
          type="h2"
          align="left"
          :code="t('home.faq.tag')"
        >
          {{ t('home.faq.title') }}
        </UiTitle>

        <dl class="mt-16 divide-y divide-gray-900/10 dark:divide-gray-100/10">
          <Disclosure
            v-for="faq in faqs"
            :key="faq.question"
            v-slot="{ open }"
            as="div"
            class="py-6 first:pt-0 last:pb-0"
          >
            <dt>
              <DisclosureButton
                class="flex w-full items-start justify-between
                text-left text-gray-900 dark:text-gray-100"
              >
                <UiParagraph
                  class="text-base/7 font-semibold"
                  size="lg"
                  align="left"
                >
                  {{ faq.question }}
                </UiParagraph>
                <span class="ml-6 flex h-7 items-center">
                  <PlusIcon
                    v-if="!open"
                    class="size-6"
                    aria-hidden="true"
                  />
                  <MinusIcon
                    v-else
                    class="size-6"
                    aria-hidden="true"
                  />
                </span>
              </DisclosureButton>
            </dt>
            <DisclosurePanel
              as="dd"
              class="mt-2 pr-12"
            >
              <UiParagraph
                size="lg"
                align="left"
              >
                {{ faq.answer }}
              </UiParagraph>
            </DisclosurePanel>
          </Disclosure>
        </dl>
      </div>
    </UiContainer>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import UiContainer from '@/components/ui/UiContainer.vue';
import UiTitle from '@/components/ui/UiTitle.vue';
import UiParagraph from '@/components/ui/UiParagraph.vue';
import { Disclosure, DisclosureButton, DisclosurePanel } from '@headlessui/vue';
import { MinusIcon, PlusIcon } from '@heroicons/vue/24/outline';

const { t } = useI18n();

// Computed
const faqs = computed(() => [
  {
    question: t('home.faq.question1'),
    answer: t('home.faq.answer1'),
  },
  {
    question: t('home.faq.question2'),
    answer: t('home.faq.answer2'),
  },
  {
    question: t('home.faq.question3'),
    answer: t('home.faq.answer3'),
  },
  {
    question: t('home.faq.question4'),
    answer: t('home.faq.answer4'),
  },
  {
    question: t('home.faq.question5'),
    answer: t('home.faq.answer5'),
  },
  {
    question: t('home.faq.question6'),
    answer: t('home.faq.answer6'),
  },
  {
    question: t('home.faq.question7'),
    answer: t('home.faq.answer7'),
  },
  {
    question: t('home.faq.question8'),
    answer: t('home.faq.answer8'),
  },
]);
</script>
